
import React, { useState, useTransition } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import {
  excelUploadAction,
  loadingMasterAction,
  columnShownUploadAction,
} from "../../redux/actions/master.action";
import { masterType } from "../../redux/type";
import { Button } from "reactstrap";
import { X } from "lucide-react";
import LoadingModel from "components/Event/LoadingModel";

const UploadExcelModal = ({ uploadType, modalTitle, icons }) => {
  const [modalShow, setModalShow] = useState(false);
  const [file, setFile] = useState(null);
  const [isPending, startTransition] = useTransition();
  const { model, message, modifiedCount} = useSelector(
    (state) => state.master
  );

  const dispatch = useDispatch();
  // Handle file selection via drag-and-drop or file input
  const handleUpload = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const selectedFile = e.target.files
      ? e.target.files[0]
      : e.dataTransfer.files[0]; // Get the file from drag or file input

    if (selectedFile && selectedFile.name.split(".").pop() === "xlsx") {
      setFile(selectedFile); // Set the selected file
    } else {
      alert("Please select a valid Excel (.xlsx) file.");
    }
  };

  // Handle file upload
 const onUpload = () => {
    if (!file) {
      alert("Please select a file first.");
      return;
    }

    dispatch(loadingMasterAction(true)); // Start showing loading UI

    // Let React update UI before starting heavy work
    startTransition(async () => {
      try {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("model", model.value);

        if (uploadType === "data") {
          await dispatch(excelUploadAction(formData));
        } else if (uploadType === "column") {
          await dispatch(columnShownUploadAction(formData));
        }
      } catch (error) {
        console.error("Upload failed", error);
      } finally {
        dispatch(loadingMasterAction(false)); // Hide loader
      }
    });
  };
  // Reset the file input and state when canceling or removing the file
  const onCancelHandle = () => {
    setModalShow(false);
    setFile(null); // Reset file state
    document.getElementById("id_12").value = null; // Reset the file input

    dispatch({
      type: masterType.UPLOAD_EXCEL,
      payload: { data: undefined },
    });
  };

  // Handle file removal
  const onRemoveFile = () => {
    setFile(null); // Reset the file state
    document.getElementById("id_12").value = null; // Reset the file input
  };
  
  return (
    <>
      <LoadingModel show={isPending} />
      <button
        type="button"
        className="btn btn-primary btn-sm rounded-circle "
        style={{ padding: "6px" }}
        onClick={() => setModalShow(true)}
      >
        {icons}
      </button>

      <Modal
        show={modalShow}
        onHide={onCancelHandle}
        size="lg"
        // aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            {modalTitle}
          </Modal.Title>

          <div>
            <button
              onClick={onCancelHandle}
              style={{ padding: "6px" }}
              className="btn btn-sm btn-outline-secondary"
            >
              <X />
            </button>
          </div>
        </Modal.Header>

        <div
          className="upload"
          onDragEnter={(e) => e.preventDefault()} // Prevent default behavior when dragging over the drop area
          onDragOver={(e) => e.preventDefault()} // Prevent default behavior when dragging over the drop area
          onDragLeave={(e) => e.preventDefault()} // Prevent default behavior when dragging out
          onDrop={handleUpload} // Handle the drop event
          style={{
            border: "2px dashed #ccc",
            padding: "20px",
            textAlign: "center",
            cursor: "pointer",
          }}
        >
          <div className="d-flex flex-column justify-content-center align-items-center gap-3">
            {/* File Name Display */}
            {file && (
              <div className="fileContainer border rounded py-3 px-2 d-flex justify-content-between align-items-center">
                <div className="overflow-hidden uploadFileName">
                  {file.name}
                </div>
                <div className="cross" onClick={onRemoveFile}>
                  {"X"}
                </div>
              </div>
            )}

            {/* Upload Button with Icon */}
            <Button
              variant="light"
              className="gap-2 d-flex py-1 px-3 my-2 border border-light align-items-center"
              onClick={() => document.getElementById("id_12").click()}
            >
              + <span className="fs-5 text-black ml-1"> Upload</span>
            </Button>

            <form className={`my-form ${file ? "link-opacity-0" : ""}`}>
              <p>Drag & Drop Excel file here</p>
              <div className="">
                <input
                  type="file"
                  id="id_12"
                  accept=".xlsx"
                  onChange={handleUpload}
                  hidden
                />
              </div>
            </form>
          </div>

          <div className="text-center">Max: 1 file (50 MB limit per file)</div>
        </div>

        <Modal.Footer className="d-flex justify-content-between">
          {/* Display file name */}

          <div>
            {uploadType === "data" ? (
              <>
                <div className="d-flex">
                  <span>Message:</span>
                  {message && (
                    <p
                      style={{
                        color: message === "successfully" ? "green" : "red",
                        marginLeft: "8px",
                        fontWeight: 600,
                      }}
                    >
                      {message === "successfully"
                        ? "Changes Applied Successfully ..."
                        : message}
                    </p>
                  )}
                </div>

                <div className="d-flex">
                  <span>Modify Count:</span>
                  <p style={{ fontWeight: 600, marginLeft: "8px" }}>
                    {modifiedCount}
                  </p>
                </div>
              </>
            ) : (
              <>
                <div className="d-flex">
                  <span>Message:</span>
                  {message && (
                    <p
                      style={{
                        color: message === "Success" ? "green" : "red",
                        marginLeft: "8px",
                        fontWeight: 600,
                      }}
                    >
                      {message === "Success"
                        ? "Changes Applied Successfully ..."
                        : message}
                    </p>
                  )}
                </div>
              </>
            )}
          </div>

          <Button onClick={onUpload}>Upload</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default React.memo(UploadExcelModal);
